import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  deleteAiVisibilityReport,
  deleteAiVisibilityRun,
} from '../../services/ai-visibility-report/AiVisibilityReportService';
import {
  GET_AI_VISIBILITY_REPORTS,
  GET_AI_VISIBILITY_RUNS,
  GET_AI_VISIBILITY_USAGE,
} from '../../query/ai-visibility-report/keys';

export const useDeleteAiVisibilityRun = (projectId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (runId: number) => deleteAiVisibilityRun(runId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [GET_AI_VISIBILITY_RUNS, projectId] });
      // Cancelling a run / dismissing a failed one marks it DELETED — the slot comes back.
      void queryClient.invalidateQueries({ queryKey: [GET_AI_VISIBILITY_USAGE] });
    },
  });
};

export const useDeleteAiVisibilityReport = (projectId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (reportId: number) => deleteAiVisibilityReport(reportId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [GET_AI_VISIBILITY_REPORTS, projectId] });
    },
  });
};
